import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function invalidateModels() {
  cache = null;
}

export function useModels() {
  const [models, setModels] = useState(cache ?? []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) return undefined;
    let alive = true;
    api.get("/models")
      .then((r) => {
        cache = Array.isArray(r.data) ? r.data : [];
        if (alive) setModels(cache);
      })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  return { models, loading };
}
